module.exports = __webpack_public_path__ + "img/grzl_03.c65ff66a.png";